import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { trans } from 'sharedKernel/i18n'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { getHubRoute } from 'sharedKernel/handlers'
import { ROUTES } from 'sharedKernel/constants'
import { showConfirmationPopUp } from 'components/popup/confirmationModal'
import { showToast } from 'components/toast'
import { deleteProvider, DeleteFormat } from 'sharedKernel/api'
import {
  HeaderWrapper,
  IconButton,
  IconButtonsWrapper,
  ScoutingPageTitle,
  TitleBlock
} from './style'

interface ScoutingHeaderProps {
  data: any
}

export const ScoutingHeader = ({ data }: ScoutingHeaderProps): JSX.Element => {
  const navigate = useNavigate()

  const handleEdit = (): void => {
    if (!data?.id) {
      showToast('error', trans('Oportunidade não encontrado para edição'))
      return
    }

    navigate(`/hub/company/scouting/${data.id}/edit`)
  }

  const onSuccessDeletion = async (): Promise<void> => {
    showToast('success', trans('Oportunidade excluída com sucesso'))
    navigate(getHubRoute(ROUTES.HUB.COMPANY.SCOUTING_LIST))
  }

  const onErrorDeletion = async (): Promise<void> => {
    showToast('error', trans('Falha ao deletar'))
  }

  const { mutate: deleteScouting } = deleteProvider(onSuccessDeletion, onErrorDeletion)

  const titleDelete = trans('Excluir Oportunidade')
  const messageDelete = trans('Deseja realmente excluir essa Oportunidade?')

  const handleDelete = (): void => {
    showConfirmationPopUp({
      title: titleDelete,
      message: messageDelete,
      onConfirm: () => {
        if (data?.id) {
          const request: DeleteFormat = {
            url: `/v1/hub/scouting/opportunity/${data.id}`
          }
          deleteScouting(request)
        }
      }
    })
  }

  return (
    <HeaderWrapper>
      <TitleBlock>
        <ScoutingPageTitle>{data?.title || trans('Carregando...')}</ScoutingPageTitle>
      </TitleBlock>
      <IconButtonsWrapper>
        <IconButton
          type="button"
          onClick={handleEdit}
          title={trans('Editar')}
          aria-label={trans('Editar')}
        >
          <FontAwesomeIcon icon={faEdit} />
        </IconButton>
        <IconButton
          type="button"
          onClick={handleDelete}
          title={trans('Excluir esse')}
          aria-label={trans('Excluir')}
        >
          <FontAwesomeIcon icon={faTrash} />
        </IconButton>
      </IconButtonsWrapper>
    </HeaderWrapper>
  )
}
